module.exports = __webpack_public_path__ + "static/media/Pepper.db6bd996.webp";